import { render, staticRenderFns } from "./ConfigurationContainer.vue?vue&type=template&id=ba1cb452&scoped=true"
import script from "./ConfigurationContainer.vue?vue&type=script&lang=js"
export * from "./ConfigurationContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1cb452",
  null
  
)

export default component.exports